import { Controller } from "react-hook-form";
import TwoStepSelectField from "../TwoStepSelectField";

const TwoStepSelectFieldV2 = ({
  name = "",
  control,
  onChange = () => {},
  ...props
}) => {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { onChange: onControllerChange } }) => (
        <TwoStepSelectField
          name={name}
          onChange={(value, label, item) => {
            onControllerChange(value);
            onChange(value, label, item);
          }}
          {...props}
        />
      )}
    />
  );
};

export default TwoStepSelectFieldV2;
